import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'prevy_analytics_consent';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = window.localStorage.getItem(CONSENT_KEY);

    if (saved === 'granted') {
      if (typeof window.__initAnalytics === 'function') {
        window.__initAnalytics();
      }
      return;
    }

    if (saved === 'denied') {
      return;
    }

    setVisible(true);
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem(CONSENT_KEY, 'granted');
    if (typeof window.__initAnalytics === 'function') {
      window.__initAnalytics();
    }
    setVisible(false);
  };

  const handleReject = () => {
    window.localStorage.setItem(CONSENT_KEY, 'denied');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-5 left-5 right-5 z-[10000] sm:left-auto sm:w-[430px]" data-testid="consent-banner">
      <div className="rounded-2xl border border-white/[0.12] bg-[#0A0A0A]/95 backdrop-blur-xl p-4 shadow-2xl">
        <p className="text-sm text-zinc-200 leading-relaxed" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Usamos cookies para mejorar nuestra web y brindar una mejor experiencia. Puedes aceptar o rechazar.
        </p>
        <div className="mt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={handleReject}
            className="rounded-lg border border-white/[0.12] px-3 py-2 text-sm text-zinc-300 hover:text-white hover:bg-white/[0.06] transition-colors"
          >
            Rechazar
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-lg bg-[#FF4F00] px-3 py-2 text-sm text-white font-medium hover:bg-[#FF6B35] transition-colors"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
